import { Form, Formik } from "formik";
import { useDispatch, useSelector } from "react-redux";
import React, { useEffect, useState } from "react";
import * as Yup from "yup";
import { Constants } from "../../Common/Constants";
import { types } from "../../../Redux/Actions/types";
import TextField from "../../Common/Fields/TextField";
import ButtonCustom from "../../Common/Fields/ButtonCustom";
import {
  primaryMuscleInsert,
  primaryMuscleList,
  primaryMuscleUpdate,
} from "../../../Redux/Actions";
import usePermissions from "../../Common/Functions/usePermissions";

const PrimaryMuscleForm = () => {
  const dispatch = useDispatch();
  const { primaryMuscleSingle } = useSelector((state) => state.PrimaryMuscle);
  // Permissions
  const addPermission = usePermissions(Constants.permission.BODY_PART_ADD);
  const editPermission = usePermissions(Constants.permission.BODY_PART_EDIT);

  // Initial values to primary muscle form
  const [initialValues, setInitialValues] = useState({
    name: "",
  });

  // Validations for primary muscle form
  const validationSchema = Yup.object().shape({
    name: Yup.string().required(Constants.required),
  });

  useEffect(() => {
    // Set initial values to pre fill body group form
    if (primaryMuscleSingle?._id) {
      const editValue = {};
      for (const [key] of Object.entries(initialValues)) {
        if (primaryMuscleSingle[key]) {
          editValue[key] = primaryMuscleSingle[key];
        }
        setInitialValues(editValue);
      }
    }
  }, [primaryMuscleSingle]);

  return (
    <Formik
      initialValues={initialValues}
      enableReinitialize={true}
      validationSchema={validationSchema}
      onSubmit={(values) => {
        // Add or update primary muscle API
        let submitFunc = primaryMuscleInsert(values);
        if (primaryMuscleSingle._id) {
          values.id = primaryMuscleSingle._id;
          submitFunc = primaryMuscleUpdate(values);
        }
        dispatch(submitFunc).then((response) => {
          if (response.error) {
            dispatch({
              type: types.ERROR_ALERT_VISIBLE,
              payload: response.error,
            });
          } else {
            dispatch({
              type: types.SUCCESS_ALERT_VISIBLE,
              payload: response.message,
            });
            dispatch({ type: types.PRIMARY_MUSCLE_SINGLE, payload: "" });
            dispatch({ type: types.PRIMARY_MUSCLE_FORM_MODEL, payload: "" });
          }
          dispatch(primaryMuscleList());
        });
      }}
    >
      {({ errors, touched }) => (
        <Form className="row">
          <div className="col-md-12 mb-2">
            <TextField
              type="text"
              name="name"
              className="form-control"
              errors={touched?.name ? errors?.name : undefined}
              touched={touched?.name}
              label={Constants.name}
            />
          </div>
          {((addPermission && !primaryMuscleSingle?._id) ||
            (editPermission && primaryMuscleSingle?._id)) && (
            <ButtonCustom label={Constants.submit} type="submit" />
          )}
        </Form>
      )}
    </Formik>
  );
};

export default PrimaryMuscleForm;
